import Lookup from 'src/componentes/select-async';
import ProcessoList from 'src/paginas/gestao-risco/processo/view';

const RiscoLookup = (props) => {
  return (
    <Lookup
      showSearch
      labelKey="nome"
      valueKey="id"
      url="/ProcessoLookup"
      hierarchy={true}
      clearable={true}
      searchComponent={ProcessoList}
      {...props}
    />
  );
};

export default RiscoLookup;
